import axios from 'axios';
import moment from 'moment';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'DimValCode','tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc','reff'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/buku${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
    listproblem(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir',  'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/buku/listproblem${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    changeDimension(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put('/buku/changedim', obj);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    kodejurnal() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/buku/kodejurnal");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    pipAccount() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/groupakun/pipaccount");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    

    getcoa(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`coa/getcoa/${obj.tahun}`);
                // console.log(`coa/getcoa/${obj.tahun}`, data);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['nomor', 'tanggal', 'kodejurnal'];
                let str = '';
                    for (const key in obj) {
                        if (keys.indexOf(key) >= 0 && obj[key]) {
                            str += str ? '&' : '?';
                            str += key + '=' + encodeURIComponent(obj[key]);
                        }
                    }
                const { data } = await axios.get(`buku/detail${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    insert(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // await axios.post("buku", obj);
                // resolve();
                const { data } = await axios.post("buku", obj);
                resolve(data);

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const { data } = await axios.delete(`buku?nomor=${encodeURIComponent(obj.nomor)}&tanggal=${encodeURIComponent(moment(obj.tanggal).format('YYYY-MM-DD'))}`);
                const keys = ['nomor', 'tanggal', 'kodejurnal'];
                let str = '';
                    for (const key in obj) {
                        if (keys.indexOf(key) >= 0 && obj[key]) {
                            str += str ? '&' : '?';
                            str += key + '=' + encodeURIComponent(obj[key]);
                        }
                    }
                const { data } = await axios.delete(`buku${str}`);
            
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url ;
            let str = '';
            try {
                switch (obj.fsubkode2) {
                    case 'arinvtt':
                        str = '?key=' + encodeURIComponent(obj.subkode2);
                        url = `/arinv/printjv`;
                        break;

                    case 'advsettlheader':
                            str = '?key=' + encodeURIComponent(obj.subkode2);
                            url = `/advsettle/printjv`;
                            break;

                    case 'expenreimburs':
                        str = '?key=' + encodeURIComponent(obj.subkode2);
                        url = `/expense/printjv`;
                        break;

                    case 'ap_invoice_tt':
                        str = '?key=' + encodeURIComponent(obj.subkode2);
                        url = `/apinv/printjv`;
                        break;

                    case 'inventory_issued':
                        str = '?key=' + encodeURIComponent(obj.subkode2);
                        url = `/inventoryout/printjv`;
                        break;
            
                    case 'tranbank':
                        str ='?key=' + encodeURIComponent(obj.subkode2);
                        if (obj.nomor.substr(1, 1) == 'M'){
                            url = `/tranbank/printreceivejv`;

                        } else {
                            url = `/tranbank/printpaymentjv`;
                        }
                        break;

                    default:
                        // // str = `?nomor=${encodeURIComponent(obj.no_jurnal)}&tanggal=${encodeURIComponent(moment(obj.tanggal).format('YYYY-MM-DD'))}`;
                        const keys = ['nomor','no_jurnal', 'tanggal', 'kodejurnal'];
                        str = '';
                        for (const key in obj) {
                            if (keys.indexOf(key) >= 0 && obj[key]) {
                                str += str ? '&' : '?';
                                str += key + '=' + encodeURIComponent(obj[key]);
                            }
                        }
                        url = `/buku/printjv`;
                        break;
                }

                url += str;
                const { data } = await axios.get(url);

                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        // return new Promise(async (resolve, reject) => {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'DimValCode', 'tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc','reff'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/buku/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'list_jurnal.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};